import { useState, useEffect } from 'react';

interface UseQueryParamResult {
    value: string;
    isError: boolean;
}
const useQueryParam = (param: string): UseQueryParamResult => {
    const [queryParamValue, setQueryParamValue] = useState<string>('');
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const value = queryParams.get(param);
            setQueryParamValue(value || '');
            setIsError(false);
        } catch (error) {
            setIsError(true);
            setQueryParamValue('');
        }
    }, [param]);

    return { value: queryParamValue, isError };
};

export default useQueryParam;
